export const RESULTADO_DIGITACAO_LABELS = {
    COMPLETO: "Pedido completo",
    PARCIAL: "Pedido parcial",
    NAO_DIGITADO: "Não conseguiu digitar",
};

const COR_RESULTADO = {
    COMPLETO: "bg-success/10 text-success",
    PARCIAL: "bg-amber-100 text-amber-700",
    NAO_DIGITADO: "bg-destructive/10 text-destructive",
};

// Resultado da etapa de Digitação (Solicitação/Recolhimento de Ativos) — só aparece depois de preenchida.
export default function DigitacaoAtivosResumo({ detalheProcesso }) {
    const resultado = detalheProcesso?.resultadoDigitacao;
    if (!resultado) return null;

    return (
        <div>
            <h3 className="text-[11px] uppercase tracking-wide font-semibold text-muted-foreground mb-2">Digitação</h3>
            <div className="flex flex-col gap-3 text-sm">
                <div className="flex flex-wrap items-center gap-3">
                    <span className={`inline-flex items-center rounded-full px-3 py-1 text-xs font-semibold ${COR_RESULTADO[resultado] || "bg-muted text-foreground"}`}>
                        {RESULTADO_DIGITACAO_LABELS[resultado] || resultado}
                    </span>
                    {detalheProcesso.numeroPedidoDigitacao && (
                        <span className="text-foreground">
                            <span className="text-muted-foreground">Nº do pedido:</span> <strong>{detalheProcesso.numeroPedidoDigitacao}</strong>
                        </span>
                    )}
                </div>
                <Texto label="Itens não digitados" valor={detalheProcesso.itensNaoDigitados} />
                <Texto label="Motivo" valor={detalheProcesso.motivoDigitacao} />
                <Texto label="Observação" valor={detalheProcesso.observacaoDigitacao} />
            </div>
        </div>
    );
}

function Texto({ label, valor }) {
    if (!valor) return null;
    return (
        <div>
            <span className="block text-[11px] uppercase tracking-wide text-muted-foreground font-semibold">{label}</span>
            <p className="text-foreground whitespace-pre-wrap">{valor}</p>
        </div>
    );
}
